import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
@Directive({
  selector: 'img[rmaBrokenImage]',
  standalone: true,
})
export class BrokenImageDirective {
  @Input()
  fallbackSrc: string | undefined;
  @Input()
  renderAlt = false;
  @Input()
  renderAltImageStyle = false;
  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
  ) {}
  @HostListener('error') onError() {
    // SAFETY(legacy): unreviewed, pre-dates this rule.
    const image: HTMLImageElement = this.el.nativeElement as HTMLImageElement;
    if (this.fallbackSrc) {
      this.renderer.setAttribute(image, 'src', this.fallbackSrc);
      return;
    }
    if (this.renderAlt) {
      const alt = image.alt;
      if (alt) {
        const parent = this.el.nativeElement.parentElement;
        if (parent) {
          const div = this.renderer.createElement('div');
          if (this.renderAltImageStyle) {
            const className = this.el.nativeElement.className;
            if (className) {
              this.renderer.addClass(div, className);
              return;
            }
          }
          const text = this.renderer.createText(alt);
          this.renderer.appendChild(div, text);
          this.renderer.appendChild(parent, div);
          return;
        }
      }
    }
    this.renderer.setStyle(image, 'display', 'none');
  }
}
